import React from 'react';
import { Account } from 'schema';
import { PropertiesTable, PropertiesTableRow } from 'ui/PropertiesTable';

export const GenericAccountInformation = ({ account }: { account: Account }) => {
  return (
    <PropertiesTable>
      <PropertiesTableRow caption="Баланс" value={account.amount} isAmount />
    </PropertiesTable>
  );
};
